var map = {
  "./pl.messages.tsx": [
    "79508",
    [
      2413
    ]
  ],
  "./cs.messages.tsx": [
    "46642",
    [
      5007
    ]
  ],
  "./en.messages.tsx": [
    "71259",
    [
      4196
    ]
  ],
  "./hu.messages.tsx": [
    "26799",
    [
      8644
    ]
  ],
  "./de.messages.tsx": [
    "48323",
    [
      4288
    ]
  ],
  "./it.messages.tsx": [
    "17373",
    [
      4590
    ]
  ],
  "./sk.messages.tsx": [
    "44858",
    [
      8551
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 72032;
module.exports = __rspack_async_context;
